<template>
  <div>
    <!-- TABLE -->
    <section class="my-5 full__row_section table-section mx-auto">
      <ejs-grid
        v-show="!showLoader"
        ref="dataGrid"
        :created="refreshGrid"
        :allowPaging="true"
        :allowSorting="true"
        :pageSettings="pageSettings"
        :toolbar="toolbar"
        :searchSettings="search"
        :allowExcelExport="true"
        :allowPdfExport="true"
        :toolbarClick="toolbarClick"
        :locale="usedLang"
      >
        <e-columns>
          <e-column width="40" field="index" headerText="#"></e-column>
          <e-column
            field="date"
            width="180"
            :headerText="$t('text.iGroup.date')"
          ></e-column>
          <e-column
            field="amount"
            width="180"
            :headerText="$t('text.iGroup.amountNaira')"
          ></e-column>

          <e-column
            field="status"
            width="180"
            :headerText="$t('text.iGroup.status')"
          ></e-column>

          <e-column
            field="description"
            width="300"
            :headerText="$t('text.iGroup.description')"
          ></e-column>
        </e-columns>
      </ejs-grid>
      <TableLoader :showLoader="showLoader" />
    </section>
  </div>
</template>

<script>
import GroupMasterLayout from "@/views/Industrial/GroupMasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    GroupMasterLayout,
    TableLoader,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  props: ["maxDate", "dateRange", "startDatee", "endDatee"],
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      startDate: this.startDatee,
      endDate: this.endDatee,
      groupID: this.$route.query.groupID,
      companyCumulativeWallet: null,
      transactions: [],
      showLoader: false,
      isDisabled: true,

      walletTransactionStartDate: this.$moment()
        .subtract(30, "days")
        .format("D-M-YYYY"),
      walletTransactionEndDate: this.$moment().format("D-M-YYYY"),
      awalletBalance: 0,

      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.getWalletTransactions();
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getWalletTransactions();
      }
    },

    groupID: function (newID, oldID) {
      localStorage.setItem("groupID", newID);
    },
  },
  mounted() {},
  computed: {
    walletStartDate() {
      return this.$moment(this.walletTransactionStartDate, "DD-MM-YYYY").format(
        "MMMM D, YYYY"
      );
    },
    walletEndDate() {
      return this.$moment(this.walletTransactionEndDate, "DD-MM-YYYY").format(
        "MMMM D, YYYY"
      );
    },
  },
  methods: {
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getWalletTransactions() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/GroupBranchWalletTransactions/${this.groupID}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.forEach((el) => {
            index++;
            el.index = index;
            el.date = new Date(el.date).toDateString();
            el.amount = el.amount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            el.currentBalance = el.currentBalance.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
        })
        .catch((error) => {});
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
.first-section {
  width: 92%;
  margin: auto auto;
}
.indus_back_img {
  background: url("../../../../../assets/img/Card balance.svg") no-repeat !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.wallet-card {
  height: 180px;
  border-radius: 20px;
  text-align: center;
  width: 350px;
  position: relative;
  box-shadow: 0px 3px 6px #0000000d;
  border-bottom: 4px solid #370f70;
}

.wallet-img {
  position: absolute;
  bottom: 13px;
  right: 0;
}

.wallet-card h5 {
  font-size: 14px;
}

.wallet-card .card-middle {
  width: 80%;
}
.wallet-card h4 {
  font-size: 35px;
}

.wallet-header {
  width: 90%;
  margin: auto auto;
}
.wallet-header {
  width: 90%;
  margin: auto auto;
}

.graph-section {
  width: 93%;
  border-radius: 30px;
}

.table-section {
  width: 95%;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav a {
  color: #2b2b2b;
  font-size: 14px;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}

.small_card {
  align-items: normal;
}
.small__card_content_wrapper {
  display: flex !important;
  justify-content: space-between;
  flex-direction: row;
  width: 93%;
  margin: auto auto;
  margin-top: 17px;
}
.dashboard__card__header {
  font-size: 12px;
  font-weight: 700;
}

.car_content_flex_wrapper {
  margin-top: 30px;
  width: 68px;
}
.small__card_content_wrapper span {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.01em;
  text-align: left;
}

@media only screen and (max-width: 600px) {
  .dashboard_chart {
    display: block;
  }
}

.table span {
  font-size: 12px;
  color: grey;
  font-weight: lighter;
}

.table-lga {
  line-height: 5px;
}
.table-lga p {
  font-size: 20px;
}
thead {
  border-bottom: 1px black solid;
}
.top_consumption button {
  padding: 10px 20px;
  border: 1px solid #494d6a;
  background-color: transparent;

  font-size: 14px;
  border-radius: 5px;
}
.table-link {
  position: absolute;
  bottom: 3%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
